export enum SensorTabs {
  ALL = 'all',
}

export enum DateTypes {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export interface IRecognizeSensor {
  message: string | null;
  recognized: boolean;
  sensor_id: string;
}

export interface IRecognizeAppKey {
  message: string | null;
  recognized: boolean;
  appkey: string | null;
}
